module.exports = __webpack_public_path__ + "static/media/clue05.1dcc9c0b.png";